import React from 'react';
import { useRecoilState } from 'recoil';
import { UserState } from '../../../../../../utils/recoil/user';
import { Link } from '../../../../Elements/Link';

interface HeaderBannerAccountLinksProps {
  login: ILink;
  myAccount: ILink;
}

export const HeaderBannerAccountLinks = ({ link }: HeaderBannerProps) => {
  return (
    <div className='hidden hover:underline lg:flex items-center justify-end'>
      <Link
        {...link}
        label={{
          ...link?.label,
          size: 'sm',
          weight: 'normal',
          color: { classname: 'white' },
        }}
      />
    </div>
  );
};
